var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name:'WorkYearPage',params:{year:_vm.year}}}},[_vm._v(_vm._s(_vm.year))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }